export function buildLivenessError(resp) {
  const { livenessScore, accessories = [], reasons = [] } = resp;

  // Flags simples
  const hasSunglasses = accessories.some(a => a.type === "Sunglasses");
  const hasGlasses = accessories.some(a => a.type === "Glasses");
  const hasMask =
    accessories.some(a =>
      (a.type || "").toLowerCase().includes("mask")
    ) || accessories.some(a => a.type === "FACE_COVER");
  const hasHeadCover = accessories.some(a =>
    [
      "Hat",
      "Cap",
      "Helmet",
      "Hood",
      "Balaclava",
      "Scarf",
      "HEAD_COVER",
    ].includes(a.type)
  );
  const faceOccluded = accessories.some(a => a.type === "FaceOccluded");
  const noImage = reasons.includes("NoImageFromLiveness");

  // Casos especiais primeiro
  if (noImage) {
    return {
      code: "NO_IMAGE",
      title: "Não conseguimos capturar sua imagem.",
      message:
        "Não recebemos uma imagem válida da câmera. Verifique se a câmera está funcionando corretamente e tente novamente.",
    };
  }

  if (hasMask) {
    return {
      code: "MASK",
      title: "Remova a máscara para continuar.",
      message:
        "Detectamos que seu rosto está coberto por máscara ou cobertura facial. Remova a cobertura, deixe o rosto totalmente visível e tente novamente.",
    };
  }

  if (hasSunglasses || hasGlasses) {
    return {
      code: "GLASSES",
      title: "Remova os óculos para continuar.",
      message:
        "Detectamos óculos na sua face (óculos comuns ou de sol). Remova-os, centralize o rosto na área indicada e tente novamente.",
    };
  }

  if (hasHeadCover) {
    return {
      code: "HEAD_COVER",
      title: "Descubra a cabeça para continuar.",
      message:
        "Detectamos boné, chapéu ou algum acessório cobrindo a cabeça. Remova o acessório, deixe o rosto bem visível e tente novamente.",
    };
  }

  if (faceOccluded) {
    return {
      code: "FACE_OCCLUDED",
      title: "Seu rosto não está totalmente visível.",
      message:
        "Identificamos que parte do seu rosto está coberta ou fora da área de captura. Centralize o rosto, evite obstruções (mão, cabelo, objetos) e tente novamente.",
    };
  }

  // Agora tratamos por qualidade de livenessScore
  if (livenessScore < 60) {
    return {
      code: "VERY_LOW_LIVENESS",
      title: "Não conseguimos confirmar sua presença.",
      message:
        "A qualidade da imagem foi muito baixa. Verifique se há boa iluminação, evite movimento brusco e aproxime um pouco o rosto da câmera antes de tentar novamente.",
    };
  }

  if (livenessScore < 95) {
    return {
      code: "LOW_LIVENESS",
      title: "Quase lá! Mas ainda não deu.",
      message:
        "Não conseguimos ter confiança suficiente para confirmar sua presença. Tente manter o rosto centralizado, não se mova muito e garanta uma boa iluminação.",
    };
  }

  // Fallback genérico
  return {
    code: "GENERIC",
    title: "Não conseguimos confirmar sua presença.",
    message:
      "A imagem capturada não foi clara o suficiente para validar que você está presente. Verifique a iluminação, centralize o rosto e tente novamente.",
  };
}
